import {
  SET_WEEKLY_TASKS,
  TaskGlobalContext,
} from '@mummssoftware/global-context';
import { dateToMMDDYYYYHyphens } from '@mummssoftware/utils/dates';
import { Nil } from '@mummssoftware/utils/primitives';
import { useContext, useState } from 'react';
import { PatientAssistanceContext } from '../../context';

const formatDateParam = (d: Date | Nil) =>
  d ? dateToMMDDYYYYHyphens(d) : null;

export const useTasksGlobalContext = () => {
  const { dispatchTask } = useContext(TaskGlobalContext);
  const { agency, siteId, patient, observation } = useContext(
    PatientAssistanceContext,
  );

  const [loadingTasks, setLoadingTasks] = useState(false);

  const setGlobalWeeklyTasks = (
    tasks: mumms.WeekSummaryTaskDto[] | Response,
  ) => {
    // A failed request resolves with the raw Response (e.g. 404); show an empty table instead of crashing.
    dispatchTask({
      type: SET_WEEKLY_TASKS,
      payload: tasks instanceof Response ? [] : tasks,
    });
  };

  const updateDateParams = (fromDate: Date | Nil, toDate: Date | Nil) => {
    setLoadingTasks(true);
    observation
      .getPatientWeeklyTasks(
        agency,
        siteId,
        patient?.patientNumber, // could be null for cross patient
        formatDateParam(fromDate),
        formatDateParam(toDate),
      )
      .then(setGlobalWeeklyTasks)
      .finally(() => {
        setLoadingTasks(false);
      });
  };

  return { loadingTasks, updateDateParams };
};
